export class UserPermissionModel {
    constructor(
        public isPermittedToEditProviderDataSource?: boolean,
        public isPermittedToEditProviderIntegration?: boolean,
        public isPermittedToEditVendorDefaultApplication?: boolean,
        public isPermittedToEditVendorIntegration?: boolean,
        public isPermittedToEditDataSchema?: boolean
    ) { }
}
